import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resources from './translations.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,

    fallbackLng: 'en',

    // https://github.com/i18next/react-i18next/issues/475
    // From the client, i18n.language simply tells us the clients preferred language but not if that
    // language is supported by our translations. These configs combined ensure that
    // i18n.languages[0] matches the language that is being used/displayed.
    // supportedLngs: ['en', 'fr'],
    // nonExplicitSupportedLngs: true,
    // load: 'languageOnly',

    interpolation: {
      escapeValue: false, // react already safes from xss
    },

    detection: {
      order: ['querystring', 'cookie', 'navigator'],
      lookupQuerystring: 'lang',
      lookupCookie: 'lang',
      lookupLocalStorage: 'lang',
      lookupSessionStorage: 'lang',

      cookieDomain: SHIELDGPS_DOMAIN,

      caches: ['cookie'],
    },
  });

export default i18n;
